import { USER } from '../actions/user';

const defaultState = JSON.parse(localStorage.getItem('user')) || {};
defaultState.profile = { message: '' };
defaultState.message = '';

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    case USER.LOGIN_DONE:
      localStorage.setItem('user', JSON.stringify(action.user));
      return { ...action.user };

    case USER.LOGIN_FAILED:
      return { ...state, message: action.message };

    case USER.NOT_AUTHORIZED:
    case USER.LOGOUT_DONE:
    case USER.LOGOUT_FAILED:
      localStorage.removeItem('user');
      return {};

    case USER.ADD_DONE:
      return { ...action.user };

    case USER.ADD_FAILED:
      return { ...state, message: action.message };

    case USER.GET_DONE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.user,
          allow_registration: !!action.user.allow_registration,
          allow_unregistration: !!action.user.allow_unregistration,
        },
        first_name: action.user.first_name,
      };

    case USER.UPDATE_DONE:
      return {
        ...state,
        profile: { ...state.profile, ...action.fields },
        first_name: action.fields.first_name,
      };

    case USER.UPDATE_FAILED:
      return {
        ...state,
        profile: { ...state.profile, message: action.message },
      };

    case USER.UPLOAD_DONE:
      return { ...state,
        profile: {
          ...state.profile,
          image: action.image,
          storage_id: action.storage_id,
          original_name: action.original_name,
        },
        user_avatar: action.image,
      };

    case USER.REMOVE_UPLOADED_DONE:
      return { ...state,
        profile: { ...state.profile, image: null, storage_id: null, original_name: null },
        user_avatar: null,
      };

    case USER.GET_SETTINGS:
      const { config, ...rest } = state;
      return { ...rest };

    case USER.GET_SETTINGS_DONE:
      return {
        ...state,
        config: action.config,
      };

    case USER.UPDATE_SETTINGS_DONE:
      return {
        ...state,
        config: { ...state.config, ...action.fields },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js